export const GET_RATE = '/get_rate';
export const GET_SINGLE_RATE = '/get_single_rate';
export const UPDATE_RATE = '/update_rate';
export const CREATE_RATE = '/create_rate';
export const REMOVE_RATE = '/remove_rate';
export const GET_ACTUAL_USES = 'rate/get_actual_use_list';
export const GET_ORDINANCE_REVISION = 'rate/get_ordinance_revision_list';

export const FORM_DATA = {
  basic_rate: '',
  sef_rate: '',
  code: '',
  kind_of_property: '',
  actual_use_id: '',
  ordinance_revision_id: ''
};

export const NAME_OPTIONS = [
  {
    label: 'Basic',
    value: 'Basic',
  },
  {
    label: 'SEF',
    value: 'SEF',
  },
];

export const KIND_OF_PROPERTY_OPTIONS = [
  {
    label: 'BUILDING',
    value: 'BUILDING',
  },
  {
    label: 'LAND',
    value: 'LAND',
  },
  {
    label: 'MACHINERY',
    value: 'MACHINERY',
  },
];